module.exports = __webpack_public_path__ + "static/media/su.3083d636.ogg";